var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.1846C1.47653 23.6195 3.51684 26.5966 6.26047 28.7047V20.1846H0.550781Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6083 31.9498C15.0669 31.9893 15.5307 32.0106 15.9996 32.0106C23.392 32.0106 29.6124 26.9968 31.4484 20.1846H14.6083V31.9498Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4484 11.8368C29.6124 5.02455 23.392 0.0107422 15.9996 0.0107422C15.5307 0.0107422 15.0669 0.0321172 14.6083 0.0716172V11.8368H31.4484Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26047 3.31665C3.51684 5.42478 1.47653 8.40184 0.550781 11.8368H6.26047V3.31665Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9239H12.5218H12.5218V0.391113C11.0431 0.718988 9.64131 1.25043 8.34781 1.95624V13.9237V13.9238H0.135438C0.046375 14.607 0 15.3035 0 16.0108C0 16.7181 0.046375 17.4146 0.135438 18.0977H8.34775H8.34781V30.0653C9.64131 30.7711 11.0431 31.3026 12.5218 31.6304V18.0979V18.0978H31.8646C31.9535 17.4146 32 16.7181 32 16.0108C32 15.3035 31.9535 14.607 31.8646 13.9239Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNorway);
export default __webpack_public_path__ + "static/media/flag_norway.3366b68ce55f8f5b12bdffac336a2e36.svg";
export { ForwardRef as ReactComponent };